import { TextDocumentDto } from "../../../../../autogen/bff-api";

// The rich-text documents in a signing order — main document first, then attachments in the order they
// are sent. Uploaded documents are not in the result: they reach the signer unconverted, so there is
// nothing for the author to check.
export const textDocumentsInSigningOrder = (
  documentIdsInOrder: string[],
  textDocuments: TextDocumentDto[]
): TextDocumentDto[] =>
  documentIdsInOrder
    .map((id) => textDocuments.find((textDocument) => textDocument.id === id))
    .filter((textDocument): textDocument is TextDocumentDto => !!textDocument);
